import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { LayoutComponent } from './core/components/layout/layout.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppConfigService } from './core/services/app-config.service';
import { ConfigStore } from './core/store/config.store';

@Component({
  selector: 'app-root',
  imports: [LayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class AppComponent {
  private configStore = inject(ConfigStore);

  ngOnInit(){
    if (this.configStore.config()?.PRODUCTION) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
        var _paq = window._paq = window._paq || [];
        _paq.push(["setCookieDomain", "*.vivobenemap.regione.veneto.it"]);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
          var u="//analytics-api.regione.veneto.it/";
          _paq.push(['setTrackerUrl', u+'matomo.php']);
          _paq.push(['setSiteId', '142']);
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
        })();
      `;
      document.head.appendChild(script);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = '<p><img src="//analytics-api.regione.veneto.it/matomo.php?idsite=142&amp;rec=1" style="border:0;" alt="" /></p>';
      document.body.appendChild(noscript);
    }
  }

}
